import * as React from "react";

import { notify, TYPE } from "@8x8/oxygen-toaster";

const useReduxQueryResponseHandlers = () => {
  const logAndNotifyFailure = React.useCallback((result) => {
    if (!result?.isError) {
      return;
    }

    const error = result?.error;
    const message =
      error?.data?.message ?? `Unknown error. See console for trace.`;
    console.trace("[useReduxQueryErrorHandling] Redux request failed.", {
      result,
    });

    notify({
      content: `Via Redux Query: ${message}`,
      type: TYPE.error,
    });
  }, []);

  return React.useMemo(
    () => ({
      logAndNotifyFailure,
    }),
    []
  );
};

export default useReduxQueryResponseHandlers;
